import { useState } from "react";
import axios from "axios";

function Weather() {
  const apiKey = process.env.REACT_APP_API_KEY;
  const [city, setcity] = useState("");
  const [weather, setWeather] = useState("");
  const [temp, setTemp] = useState("");
  const [desc, setdesc] = useState("");
  const [humidity, setHumidity] = useState("");
  const [wind, setWind] = useState("");
  const [localTime, setLocalTime] = useState("");

  function handleCity(evt) {
    setcity(evt.target.value);
  }

  function getWeather() {
    var weatherData = axios(
      `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKey}&units=metric`,
    );

    weatherData
      .then(function (Success) {
        setWeather(Success.data.weather[0].main);
        setTemp(Success.data.main.temp);
        setdesc(Success.data.weather[0].description);
        setHumidity(Success.data.main.humidity);
        setWind(Success.data.wind.speed);

        const utcMs = Date.now() + new Date().getTimezoneOffset() * 60000;

        setLocalTime(
          new Date(utcMs + Success.data.timezone * 1000).toLocaleTimeString(
            [],
            {
              hour: "2-digit",
              minute: "2-digit",
            },
          ),
        );
      })

      .catch(function (Error) {
        console.error("City not found", Error);

        setWeather("City not found");
        setTemp("");
        setdesc("");
        setHumidity("");
        setWind("");
        setLocalTime("");
      });
  }

  return (
    <div className="min-h-screen bg-black text-white overflow-x-hidden relative flex items-start lg:items-center lg:justify-center p-3 sm:p-4 md:p-6">
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute w-72 h-72 sm:w-[420px] sm:h-[420px] md:w-[500px] md:h-[500px] bg-cyan-500/20 rounded-full blur-[100px] sm:blur-[130px] md:blur-[150px] top-[-120px] left-[-220px] animate-pulse"></div>

        <div className="absolute w-72 h-72 sm:w-[360px] sm:h-[360px] md:w-[400px] md:h-[400px] bg-fuchsia-500/20 rounded-full blur-[100px] sm:blur-[130px] md:blur-[150px] bottom-[-120px] right-[-220px] animate-pulse"></div>
      </div>

      <div className="relative w-full max-w-6xl mx-auto border border-white/10 bg-black/20 rounded-3xl sm:rounded-[40px] p-4 sm:p-6 md:p-8 shadow-2xl">
        <div className="flex flex-col gap-5 sm:flex-row sm:justify-between sm:items-center border-b border-white/10 pb-5 sm:pb-6">
          <div className="min-w-0">
            <h1 className="text-4xl sm:text-5xl md:text-6xl font-black tracking-tight">
              AERIS
            </h1>

            <p className="text-slate-400 mt-2 text-sm sm:text-base md:text-lg">
              I’ll help you read the sky before it speaks.
            </p>
          </div>

          <div className="hidden md:flex flex-col items-end shrink-0">
            <div className="flex items-center gap-3">
              <div className="relative flex items-center justify-center">
                <div className="w-3 h-3 bg-green-400 rounded-full"></div>

                <div className="absolute w-3 h-3 bg-green-400 rounded-full animate-ping"></div>
              </div>

              <p className="text-slate-500 uppercase tracking-[3px] lg:tracking-[5px] text-xs lg:text-sm">
                Atmospheric Engine
              </p>
            </div>
          </div>
        </div>

        <div className="mt-7 sm:mt-10 flex flex-col md:flex-row gap-4 sm:gap-5">
          <div className="flex-1 relative">
            <input
              onChange={handleCity}
              type="text"
              placeholder="Enter a city..."
              className="w-full bg-black/40 border border-white/10 rounded-2xl p-4 sm:p-5 pr-12 text-base sm:text-lg outline-none focus:border-cyan-400 transition-all duration-300 placeholder:text-slate-600"
            />

            <div className="absolute right-4 sm:right-5 top-1/2 -translate-y-1/2 text-slate-500">
              ⌖
            </div>
          </div>

          <button
            onClick={getWeather}
            className="w-full md:w-auto bg-white text-black px-6 sm:px-10 py-4 sm:py-5 rounded-2xl font-bold tracking-wide hover:scale-[1.02] hover:bg-cyan-300 transition-all duration-300 shadow-2xl"
          >
            SCAN SKY
          </button>
        </div>

        <div className="grid lg:grid-cols-3 gap-5 sm:gap-6 mt-7 sm:mt-10">
          <div className="lg:col-span-2 bg-black/20 border border-white/10 rounded-3xl sm:rounded-[35px] p-5 sm:p-6 md:p-8 relative overflow-hidden">
            <div className="absolute w-64 h-64 bg-cyan-400/10 rounded-full blur-3xl top-[-40px] right-[-40px]"></div>

            <p className="uppercase tracking-[3px] sm:tracking-[6px] text-slate-500 text-xs sm:text-sm">
              Current Forecast
            </p>

            <div className="mt-6 flex flex-col md:flex-row md:items-center md:justify-between gap-8">
              <div className="min-w-0">
                <h1 className="text-6xl sm:text-[80px] md:text-[110px] leading-none font-black tracking-tight break-words">
                  {temp}°C
                </h1>

                <p className="text-2xl sm:text-3xl text-cyan-300 font-semibold mt-4 break-words">
                  {weather}
                </p>

                <p className="text-slate-400 text-base sm:text-lg capitalize mt-2 break-words">
                  {desc}
                </p>

                <div className="mt-6 flex items-center gap-3 min-w-0">
                  <div className="w-2 h-2 bg-cyan-400 rounded-full animate-pulse shrink-0"></div>

                  <p className="text-slate-400 tracking-[2px] sm:tracking-[3px] uppercase text-xs sm:text-sm break-words">
                    Local Time : {localTime}
                  </p>
                </div>
              </div>

              <div className="mt-2 md:mt-0 flex justify-center md:justify-end shrink-0">
                <div className="w-36 h-36 sm:w-44 sm:h-44 md:w-52 md:h-52 rounded-full border border-white/10 bg-black/20 flex items-center justify-center text-5xl sm:text-6xl md:text-7xl hover:scale-105 transition-all duration-500">
                  {weather === "Clouds"
                    ? "☁️"
                    : weather === "Rain"
                      ? "🌧️"
                      : weather === "Clear"
                        ? "☀️"
                        : weather === "Thunderstorm"
                          ? "⛈️"
                          : weather === "Fog" ||
                              weather === "Haze" ||
                              weather === "Mist"
                            ? "🌫️"
                            : weather === "Snow"
                              ? "❄️"
                              : "🌍"}
                </div>
              </div>
            </div>
          </div>

          <div className="space-y-5 sm:space-y-6">
            <div className="bg-black/20 border border-white/10 rounded-3xl sm:rounded-[30px] p-5 sm:p-6 hover:-translate-y-1 transition-all duration-300">
              <p className="text-slate-500 uppercase tracking-[3px] sm:tracking-[4px] text-xs sm:text-sm">
                Humidity
              </p>

              <h1 className="text-4xl sm:text-5xl md:text-6xl font-black mt-4 break-words">
                {humidity}%
              </h1>

              <div className="w-full bg-white/10 h-2 rounded-full mt-6 overflow-hidden">
                <div
                  style={{ width: `${humidity}%` }}
                  className="bg-cyan-400 h-full rounded-full"
                ></div>
              </div>
            </div>

            <div className="bg-black/20 border border-white/10 rounded-3xl sm:rounded-[30px] p-5 sm:p-6 hover:-translate-y-1 transition-all duration-300">
              <p className="text-slate-500 uppercase tracking-[3px] sm:tracking-[4px] text-xs sm:text-sm">
                Wind Velocity
              </p>

              <h1 className="text-4xl sm:text-5xl md:text-6xl font-black mt-4 break-words">
                {wind}
              </h1>

              <p className="text-slate-400 mt-2 text-sm sm:text-base">
                km/h atmospheric movement
              </p>
            </div>
          </div>
        </div>

        <div className="mt-6 sm:mt-8 border border-white/10 rounded-3xl sm:rounded-[30px] p-5 sm:p-6 bg-black/20 flex flex-col md:flex-row md:items-center md:justify-between gap-5">
          <div className="min-w-0">
            <p className="text-slate-500 uppercase tracking-[3px] sm:tracking-[5px] text-xs sm:text-sm">
              Atmospheric Status
            </p>

            <h1 className="text-lg sm:text-xl md:text-2xl font-bold mt-2 break-words">
              {weather
                ? `Sky conditions detected in ${city}`
                : "Awaiting city scan..."}
            </h1>
          </div>

          <div className="mt-0 shrink-0">
            <p className="text-slate-400 text-base sm:text-lg italic text-right">
              “Every cloud carries a signal.”
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Weather;
